export default "__VITE_ASSET__Dn2_n24B__"